module.exports = [{
      plugin: require('/codebuild/output/src316331813/src/website/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/codebuild/output/src316331813/src/website/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-WS4R2NR","includeInDevelopment":false},
    },{
      plugin: require('/codebuild/output/src316331813/src/website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
